export const STATSIG_CLIENT_KEY =
    'client-Vp3Oe1HevIDVQ1ZmwKjt0AGx6HK1osdC2x4we07JVsU';

export const STATSIG_OVERRIDE_PARAM = 'overrideStatsig';

export const STATSIG_LOGIN_INTERSTITIAL_EXPERIMENT_KEY =
    'login_as_interstitial_step_in_checkout';

export const STATSIG_APPLE_PAY_EXPERIMENT_KEY = 'apple_pay_in_checkout';
export const STATSIG_APPLE_PAY_PARAM = 'has_apple_pay';

export const STATSIG_EVENT_NAMES = {
    LOGIN_INTERSTITIAL_LOAD: 'LoginInterstitialLoad',
    LOGIN_SUCCESS_ONE_STEP: 'LoginSuccessOneStep',
    CHECKOUT_LOAD: 'CheckoutLoad',
    COMPLETE_CHECKOUT_CLICK: 'CompleteCheckoutClick',
    ORDER_SUCCESS_LOAD: 'OrderSuccessLoad',
    APPLE_PAY_SHOWED: 'ApplePayShowed',
    PAYMENT_SELECTION: 'PaymentSelection',
    APPLE_PAY_CANCELED: 'ApplePayCanceled',
    APPLE_PAY_CLICKED: 'ApplePayClicked',
};
